import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCzechRepublicFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78663 8.78681V29.9997H59.9999C59.9999 24.0662 58.2403 18.2659 54.9437 13.3324C51.6472 8.39891 46.9616 4.55378 41.4797 2.28327C35.9978 0.0127721 29.9658 -0.581122 24.1463 0.576698C18.3269 1.73452 12.9815 4.59205 8.78607 8.78792L8.78663 8.78681Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78663 29.9998V51.2132L8.78607 51.2121C12.9815 55.408 18.327 58.2656 24.1465 59.4234C29.9659 60.5812 35.9981 59.9872 41.48 57.7167C46.9619 55.4461 51.6474 51.6009 54.9439 46.6673C58.2405 41.7337 60 35.9334 59.9999 29.9998H8.78663Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78671 8.78687C3.16067 14.413 0 22.0436 0 30.0001C0 37.9566 3.16067 45.5872 8.78671 51.2133L30.0003 29.9998L8.78671 8.78687Z",
			fill: "#428BC1"
		})
	]
});
export default SvgCzechRepublicFlag;
